import { LAYOUTS, } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { needHelp, retryAction } from "./actions";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const template = (height, isFromEnhanceLimit) => ({
    layout: {
        id: ROUTE.AS_ES_DOCUMENT_REJECTED,
        type: LAYOUTS.LIST,
        widgets: [
            {
                id: "asESDocumentsRejected", type: WIDGET.AS_ES_DOCUMENTS_REJECTED
            }
        ],
    },
    datastore: {
        asESDocumentsRejected: {
            height: height,
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.AS_ES_DOCUMENT_REJECTED,
                payload: {}
            },
            retryAction: {
                type: ACTION.RETRY_ACTION,
                routeId: ROUTE.AS_ES_DOCUMENT_REJECTED,
                payload: {}
            },
            isFromEnhanceLimit: isFromEnhanceLimit,
        }
    },
});
export const asESDocumentsRejectedMF = {
    onLoad: async ({ getHeight, network }) => {
        const isFromEnhanceLimit = await AsyncStorage.getItem("application_id") !== null;
        return Promise.resolve(template(getHeight(), isFromEnhanceLimit));
    },
    actions: {
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.RETRY_ACTION]: retryAction,
    },
    clearPrevious: true,
};
